/**
 * Конфигурация приложения
 * Централизованное хранение всех конфигурационных данных
 */

// ===== API ENDPOINTS =====
export const API_ENDPOINTS = {
  GRAPHQL: process.env.VUE_APP_GRAPHQL_URL || 'https://api.tovari-kron.ru/v1/graphql'
}

// ===== SITE =====
/** Канонический адрес для шаринга (кириллица, без www) */
export const PUBLIC_SITE_ORIGIN = process.env.VUE_APP_PUBLIC_SITE_ORIGIN || 'https://крон.рф'
export const SITE_URL = process.env.VUE_APP_SITE_URL || PUBLIC_SITE_ORIGIN

// ===== CONTACT EMAILS =====
export const CONTACT_EMAILS = {
  MAIN: 'info@tovari-kron.ru',
  SOUTH: 'ug@tovari-kron.ru',
  POLICY: 'info@tovari-kron.ru'
}

// ===== EXTERNAL URLS =====
export const EXTERNAL_URLS = {
  WHATSAPP: 'https://wa.me/79057324716',
  APP_STORE: 'https://apps.apple.com/ru/app/%D0%BA%D1%80%D0%BE%D0%BD-%D0%B8%D0%BD%D1%82%D0%B5%D1%80%D0%BD%D0%B5%D1%82-%D0%BC%D0%B0%D0%B3%D0%B0%D0%B7%D0%B8%D0%BD/id1611541742',
  RUSTORE: 'https://www.rustore.ru/catalog/app/ru.tovarikron.android'
}

// ===== REGIONS =====
export const REGIONS = {
  MOSCOW: {
    id: 'moscow',
    name: 'Москва',
    phone: '+7 (495) 799-26-66',
    phoneHref: 'tel:+74957992666',
    email: 'info@tovari-kron.ru',
    emailHref: 'mailto:info@tovari-kron.ru',
    address: 'Домодедовское шоссе, 4-й километр, 15Б',
    timezone: 'Europe/Moscow',
    workingHours: { weekdays: 'Понедельник – Суббота: 9:00 – 19:00' },
    // Домодедовское шоссе, 4-й километр, 15Б
    mapCenter: [55.438711, 37.662964],
    mapZoom: 16,
    mapUrl: 'https://yandex.ru/maps/?pt=37.662964,55.438711&z=16'
  },
  STAVROPOL: {
    id: 'stavropol',
    name: 'Ставропольский край',
    phone: '+7 (903) 418-16-66',
    phoneHref: 'tel:+79034181666',
    email: 'ug@tovari-kron.ru',
    emailHref: 'mailto:ug@tovari-kron.ru',
    address: 'с. Надежда, ул. Орджоникидзе 79',
    timezone: 'Europe/Moscow',
    workingHours: { weekdays: 'Понедельник – Суббота: 9:00 – 19:00' },
    // с. Надежда, ул. Орджоникидзе 79
    mapCenter: [45.039356, 42.080726],
    mapZoom: 16,
    mapUrl: 'https://yandex.ru/maps/?pt=42.080726,45.039356&z=16'
  }
}

